module.exports = __webpack_public_path__ + "static/Rugile_Matuseviciute-be526a6747e1c9c3ed4c14830c9d1ae4.jpg";